import { styled } from '@mui/material/styles';

export const ContentWrapper = styled('div')(() => ({
	marginLeft: 32,
}));
